import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

export const TargetContext = createContext<ShadowRoot | null>(null)

/** Provides the shadow root target of the widget. */
export const TargetProvider: FC<
  PropsWithChildren<{ target: ShadowRoot | null }>
> = ({ target, children }) => {
  return (
    <TargetContext.Provider value={target}>{children}</TargetContext.Provider>
  )
}

/** @returns The shadow root target of the widget. */
export function useTarget(): ShadowRoot | null {
  return useContext(TargetContext)
}
